<template>
  <ion-page>
    <ion-content>
      <ion-grid class="ion-margin-horizontal">
        <ion-row v-if="progress_step != 2">
          <ion-col class="ion-text-center" size="12">
            <label class="font-bold" style="font-size: 20px">オンラインショップとIDを連携する</label>
          </ion-col>
        </ion-row>
        <div v-if="progress_step == 0">
          <p class="text-sm text-blue font-bold">オンラインショップ会員に新規登録します。</p>
          <p class="text-sm text-blue font-bold ion-no-margin ion-margin-top">登録後に会員情報を変更や退会をすると、アプリとオンラインショップの情報も同時に更新されます。</p>

          <p class="font-bold">お客様情報</p>

          <RequiredInput label="姓"/>
          <ion-row>
            <ion-col size="12">
              <ion-input class="required-input" v-model="last_name" helper-text="例）山田"></ion-input>
              <ion-text color="danger" v-if="errors && errors.last_name" >{{ errors.last_name }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="名"/>
          <ion-row>
            <ion-col size="12">
              <ion-input class="required-input" v-model="first_name" helper-text="例）太郎"></ion-input>
              <ion-text color="danger" v-if="errors && errors.first_name" >{{ errors.first_name }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="姓（カナ）"/>
          <ion-row>
            <ion-col size="12">
              <ion-input class="required-input" v-model="last_name_kana" helper-text="例）ヤマダ"></ion-input>
              <ion-text color="danger" v-if="errors && errors.last_name_kana" >{{ errors.last_name_kana }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="名（カナ）"/>
          <ion-row class="ion-margin-bottom">
            <ion-col size="12">
              <ion-input class="required-input" v-model="first_name_kana" helper-text="例）タロウ"></ion-input>
              <ion-text color="danger" v-if="errors && errors.first_name_kana" >{{ errors.first_name_kana }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="郵便番号"/>
          <ion-row>
            <ion-col size="6">
              <ion-input class="required-input" v-model="postal_code" helper-text="例）1000000"></ion-input>
              <ion-text color="danger" v-if="errors && errors.postal_code" >{{ errors.postal_code }}</ion-text>
            </ion-col>
            <ion-col size="6">
              <ion-button @click="getPostalCode" color="dark" class="ion-no-margin" expand="block">住所の自動入力</ion-button>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="都道府県"/>
          <ion-row>
            <ion-col size="12">
              <ion-item class="required-input">
                <ion-select placeholder="都道府県" v-model="prefecture_id">
                  <ion-select-option :key="prefecture.id" v-for="prefecture of allPrefectures" :value="prefecture.id">{{ prefecture.name }}</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-text color="danger" v-if="errors && errors.prefecture_id">{{ errors.prefecture_id }}</ion-text>
            </ion-col>
          </ion-row>


          <RequiredInput class="ion-margin-top" label="市区町村・番地"/>
          <ion-row>
            <ion-col size="12">
              <ion-input class="required-input" v-model="address"></ion-input>
              <ion-text color="danger" v-if="errors && errors.address" >{{ errors.address }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="建物名・部屋番号" :required="false"/>
          <ion-row>
            <ion-col size="12">
              <ion-input class="required-input" v-model="building_room" helper-text="例）◯◯マンション101"></ion-input>
              <ion-text color="danger" v-if="errors && errors.building_room" >{{ errors.building_room }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="電話番号"/>
          <ion-row class="ion-margin-bottom">
            <ion-col size="12">
              <ion-input class="required-input" v-model="phone_number" helper-text="例）0311112222"></ion-input>
              <ion-text color="danger" v-if="errors && errors.phone_number" >{{ errors.phone_number }}</ion-text>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col><ion-label class="font-bold">メールアドレス</ion-label></ion-col>
            <ion-col size="12">
              <ion-input class="required-input" v-model="email" :disabled="true"></ion-input>
              <ion-text disabled="disabled" color="danger" v-if="errors && errors.email" >{{ errors.email }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="パスワード"/>
          <ion-row>
            <ion-col>
              <ion-label class="font-bold" style="font-size: 12px" >ID連携後、アプリとオンラインショップの両方で使うパスワードを設定してください。</ion-label>
            </ion-col>
            <ion-col size="12">
              <ion-input :type="show_password ? 'text' : 'password'" class="required-input" v-model="password" :validate="checkSingleByteNumbers" helper-text="パスワードは半角8～20文字、英字・数字混在で入力してください。">
                <ion-button slot="end" size="small" @click="show_password = !show_password">
                  <ion-icon slot="icon-only" color="black" :icon="eye"></ion-icon>
                </ion-button>
              </ion-input>
              <ion-text color="danger" v-if="errors && errors.password" >{{ errors.password }}</ion-text>
            </ion-col>
          </ion-row>
          <RequiredInput class="ion-margin-top" label="パスワード（確認）"/>
          <ion-row>
            <ion-col size="12">
              <ion-input :type="show_confirm_password ? 'text' : 'password'" class="required-input" v-model="password_confirmation" helper-text="パスワードは半角8～20文字、英字・数字混在で入力してください。">
                <ion-button slot="end" size="small" @click="show_confirm_password = !show_confirm_password">
                  <ion-icon slot="icon-only" color="black" :icon="eye"></ion-icon>
                </ion-button>
              </ion-input>
              <ion-text color="danger" v-if="errors && errors.password_confirmation" >{{ errors.password_confirmation }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="性別"/>
          <ion-row>
            <ion-col size="auto">
              <ion-radio-group v-model="gender">
                <ion-radio label-placement="end" :value="1">男性</ion-radio>
                <ion-radio label-placement="end" :value="2">女性</ion-radio>
                <ion-radio label-placement="end" :value="3">登録しない</ion-radio>
              </ion-radio-group>
              <ion-text color="danger" v-if="errors && errors.gender" >{{ errors.gender }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="生年月"/>
          <ion-row>
            <ion-col size="auto">
              <ion-item class="required-input">
                <ion-select v-model="birth_year" placeholder="年">
                  <ion-select-option :key="year" v-for="year in years" :value="year">{{ year }}</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
            <ion-col size="auto">
              <ion-item class="required-input">
                <ion-select v-model="birth_month" placeholder="月">
                  <ion-select-option :key="month" v-for="month in months" :value="month">{{ month }}</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="12">
              <ion-text color="danger" v-if="errors && errors.birth_date">{{ errors.birth_date }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-text color="danger" v-if="errors && errors.birth_year">{{ errors.birth_year }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-text color="danger" v-if="errors && errors.birth_month">{{ errors.birth_month }}</ion-text>
            </ion-col>
          </ion-row>

          <RequiredInput label="ご職業" :required="false"/>
          <ion-row>
            <ion-col size="12">
              <ion-item class="required-input">
                <ion-select v-model="occupation">
                  <ion-select-option :key="index" v-for="(occupation, index) of occupations" :value="occupation.value">{{ occupation.label }}</ion-select-option>
                </ion-select>
              </ion-item>
            </ion-col>
          </ion-row>

          <RequiredInput class="ion-margin-top" label="お気に入り店舗"/>
          <ion-row>
            <ion-col size="12">
              <ion-radio-group v-model="store_search_type">
                <ion-radio label-placement="end" :value="1">店舗の種類から検索</ion-radio>
                <ion-radio label-placement="end" :value="2">店舗コードから検索</ion-radio>
              </ion-radio-group>
            </ion-col>
          </ion-row>
          <div v-if="store_search_type == 1">
            <ion-row>
              <ion-col size="12">
                <ion-item class="required-input">
                  <ion-select @ionChange="fetchPrefectures()" placeholder="店舗の種類" v-model="selected_brand">
                    <ion-select-option :key="brand.name" v-for="brand of brands" :value="brand.id">{{ brand.name }}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-item class="required-input">
                  <ion-select @ionChange="fetchStores()" placeholder="都道府県" v-model="selected_prefecture">
                    <ion-select-option :key="prefecture" v-for="prefecture of prefectures" :value="prefecture.id">{{ prefecture.name }}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-item class="required-input">
                  <ion-select placeholder="店舗名" v-model="selected_store">
                    <ion-select-option :key="store.id" v-for="store of stores" :value="store.id">{{ store.name }}</ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
          </div>
          <div v-if="store_search_type == 2">
            <ion-row>
              <ion-col size="9">
                <ion-input class="required-input" style="height: 100%" v-model="store_code" placeholder="店舗コード"></ion-input>
              </ion-col>
              <ion-col size="3">
                <ion-button class="primary-button" @click="searchStore" expand="block">検索 ></ion-button>
              </ion-col>
              <ion-col size="12" v-if="show_store_error">
                <ion-text color="danger">店舗が見つかりませんでした。</ion-text>
              </ion-col>
              <ion-col size="12">
                <ion-text>{{ brands.find((brand: Brand) => brand.id == selected_brand)?.name ?? '' }}</ion-text>
              </ion-col>
              <ion-col size="12">
                <ion-text>{{ prefectures.find((prefecture: Prefecture) => prefecture.id == selected_prefecture)?.name ?? '' }}</ion-text>
              </ion-col>
              <ion-col size="12">
                <ion-text>{{ stores.find((store: Store) => store.id == selected_store)?.name ?? '' }}</ion-text>
              </ion-col>
            </ion-row>
          </div>
          <ion-text color="danger" v-if="errors && errors.store_id">{{ errors.store_id }}</ion-text>

          <hr style="background: grey"/>
          <ion-label class="font-bold" style="font-size: 15px">今後、公式オンラインショップからのお知らせメールを受け取りますか？</ion-label><br/>

          <ion-row>
            <ion-col size="12">
              <ion-radio-group v-model="mail_flg">
                <ion-radio label-placement="end" :value="2">受け取る</ion-radio>
                <ion-radio label-placement="end" :value="null">受け取らない</ion-radio>
              </ion-radio-group>
              <ion-text color="danger" v-if="errors && errors.mail_flg" >{{ errors.mail_flg }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-label style="color: grey; font-size: 15px">※特典を受け取るためには、メルマガ会員の登録が必要です。</ion-label><br/>
              <ion-label style="color: grey; font-size: 15px">※特典はメルマガにてご案内いたします。（不定期配信）</ion-label><br/>
              <ion-label style="color: grey; font-size: 15px">※「info.kutsu.com」「chiyodagrp.co.jp」からのメールが受信できるよう受信設定してください。</ion-label><br/>
              <ion-label style="color: grey; font-size: 15px">※上記の設定にかかわらず、アプリからのお知らせメールは配信されます。</ion-label><br/>
              <ion-label style="color: grey; font-size: 15px">アプリのお知らせメールを解除される場合は、受信されたメールより配信停止の設定をお願いいたします。</ion-label>
            </ion-col>
          </ion-row>

          <ion-row class="ion-margin-top">
            <ion-col size="12">
              <ion-label class="font-bold" style="font-size: 20px">kutsu.com公式オンラインショップ利用規約</ion-label>
            </ion-col>
            <ion-col size="12">
              <ion-label>会員登録の際は、必ず利用規約をお読みいただき、同意のうえご登録ください。</ion-label>
            </ion-col>
            <ion-col size="12">
              <ion-row>
                <ion-checkbox class="ion-no-margin" label-placement="end" :checked="is_agreed_to_terms" @ionChange="is_agreed_to_terms = $event.detail.checked">
                  <span @click.stop>
                    <a class="terms-link" href="#" @click.prevent="openTermsModal(termsUrl)">利用規約</a>に同意する
                  </span>
                </ion-checkbox>
                <RequiredInput/>
              </ion-row>
            </ion-col>
            <ion-col size="12">
              <ion-text color="danger" v-if="errors && errors.is_agreed_to_terms">{{ errors.is_agreed_to_terms }}</ion-text>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <ion-button class="ion-margin-top primary-button" :disabled="!is_agreed_to_terms" @click="progress_step = 1" expand="block">入力内容の確認へ進む ></ion-button>
            </ion-col>
          </ion-row>

          <ion-row>
            <ion-col>
              <ion-button class="ion-margin-top secondary-button" @click="progress_step = 0" expand="block" fill="outline" >会員証に戻る ></ion-button>
            </ion-col>
          </ion-row>
          </div>
          <div v-else-if="progress_step == 1">
            <p class="text-sm">以下の情報でオンラインショップとID連携いたします。</p>
            <p class="text-sm">登録後に会員情報を変更や退会をすると、アプリとオンラインショップの情報も同時に更新されます。</p>
            <p class="text-sm">ご入力内容に誤りがないかご確認ください。よろしければ「オンラインショップ会員に新規登録・ID連携する」ボタンを押してください。</p>

            <p class="font-bold">お客様情報</p>

            <ion-row>
              <ion-col size="5">
                <ion-text class="font-bold">姓：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ last_name }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">名：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ first_name }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">姓（カナ）：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ last_name_kana }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">名（カナ）：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ first_name_kana }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">郵便番号：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ postal_code }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">都道府県：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ allPrefectures.find((prefecture: Prefecture) => prefecture.id == prefecture_id)?.name ?? '' }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">市区町村・番地：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ address }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">建物名・部屋番号：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ building_room }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">電話番号：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ phone_number }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">メールアドレス：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ email }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">パスワード：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">************</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">性別：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ gender == 1 ? '男性' : gender == 2 ? '女性' : '登録しない' }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">生年月：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ birth_year }}年{{ birth_month }}月</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">ご職業：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ occupation }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">お気に入り店舗：</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ brands.find((brand: Brand) => brand.id == selected_brand)?.name ?? '' }}</ion-text>
                <br/>
                <ion-text class="font-bold">{{ prefectures.find((prefecture: Prefecture) => prefecture.id == selected_prefecture)?.name ?? '' }}</ion-text>
                <br/>
                <ion-text class="font-bold">{{ stores.find((store: Store) => store.id == selected_store)?.name ?? '' }}</ion-text>
              </ion-col>
              <ion-col size="5">
                <ion-text class="font-bold">メールマガジン</ion-text>
              </ion-col>
              <ion-col size="7">
                <ion-text class="font-bold">{{ mail_flg == 2 ? '受け取る' : '受け取らない' }}</ion-text>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <ion-item-divider class="font-bold">
                  <ion-row style="background: #E6E6E6; padding-left: 20px">
                    <ion-col size="12">
                      <ion-label>ポイント</ion-label>
                    </ion-col>

                    <ion-col size="2"></ion-col>
                    <ion-col size="3">
                      <ion-text>EC</ion-text>
                    </ion-col>
                    <ion-col size="1">:</ion-col>
                    <ion-col size="6">0pt</ion-col>

                    <ion-col size="2"></ion-col>
                    <ion-col size="3">
                      <ion-text>アプリ</ion-text>
                    </ion-col>
                    <ion-col size="1">:</ion-col>
                    <ion-col size="6">{{ point }}pt</ion-col>

                    <ion-col size="2"></ion-col>
                    <ion-col size="3">
                      <ion-text>合計</ion-text>
                    </ion-col>
                    <ion-col size="1">:</ion-col>
                    <ion-col size="6">{{ point }}pt</ion-col>
                  </ion-row>
                </ion-item-divider>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <ion-button class="ion-margin-top font-bold primary-button" @click="validateForm" expand="block">オンラインショップ会員に<br/>新規登録・ID連携する</ion-button>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <ion-button class="ion-margin-top secondary-button" @click="progress_step = 0" expand="block" fill="outline" >戻る ></ion-button>
              </ion-col>
            </ion-row>
          </div>

        <div v-else-if="progress_step == 2">
          <ion-header style="font-weight: bold; font-size: 22px" class="ion-margin-vertical ion-text-center">ID連携が完了しました！</ion-header>
          <div class="ion-text-center">
            <img alt='unite-complete' :src="UniteCompleteImage"/>
          </div>
          <ion-button class="ion-margin-top font-bold secondary-button" fill="outline" expand="block" @click="goBackToMembershipCard()">会員証に戻る ></ion-button>
        </div>
      </ion-grid>
    </ion-content>

  </ion-page>
</template>

<script setup lang="ts">
import {
  IonCol,
  IonRow,
  IonPage,
  IonContent,
  IonGrid,
  IonText,
  IonInput,
  IonSelect,
  IonSelectOption,
  IonButton,
  IonIcon,
  IonRadioGroup,
  IonRadio,
  onIonViewWillEnter,
  IonHeader,
  alertController, LoadingOptions, loadingController,
} from "@ionic/vue";
import {useField, useForm, useFormErrors} from "vee-validate";
import RequiredInput from "@/components/RequiredInput.vue";
import {listAllPrefectures, Prefecture} from "@/actions/list-prefectures";
import {onMounted, ref, watch} from "vue";
import {eye} from "ionicons/icons";
import {Brand, getBrands, getPrefectures, getStoreByCode, getStores} from "@/actions/favorite-store";
import UniteCompleteImage from "@/assets/ec_icon/unite_complete_image.png";
import {goBackToMembershipCard} from "@/helpers/platform";
import {occupations} from "@/consts/enums";
import {getAddressFromPostalCode, PostalData} from "@/helpers/kenall";
import request from "@/utils/Request";
import {datadogLogs} from "@datadog/browser-logs";
import * as yup from "yup";
import {KATAKANA_PATTERN, KATAKANA_ERROR_MESSAGE} from "@/consts/validation";
import {memberCard} from "@/actions/member-card";
import {profile} from "@/actions/profile";
import {Store} from "@/actions/list-stores";
import stringWidth from "string-width";
import { appendUtmParams } from "@/utils/url-utils";
import { presentToast } from "@/helpers/presentToast";

const termsBaseUrl: string = import.meta.env.VITE_EC_TERMS_URL || '';
if (!termsBaseUrl) {
  console.error('VITE_EC_TERMS_URL is not defined');
}
const termsUrl: string = termsBaseUrl ? appendUtmParams(termsBaseUrl) : '';

const store_code = ref('');
const point = ref(0);
const store_search_type = ref(1);
const currentYear = new Date().getFullYear();
const startYear = 1900;
const years = Array.from({ length: currentYear - startYear + 1 }, (_, index) => currentYear - index);

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

const schema = yup.object({
  last_name: yup.string()
      .required('姓をご入力ください')
      .test(
          'max-width',
          `姓は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      ),
  first_name: yup.string()
      .required('名をご入力ください')
      .test(
          'max-width',
          `名は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      ),
  first_name_kana: yup.string()
      .required('名（カナ）をご入力ください')
      .test(
          'max-width',
          `名（カナ）は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      )
      .test('katakana', `名（カナ）は${KATAKANA_ERROR_MESSAGE}`, function(value) {
        return KATAKANA_PATTERN.test(value);
      }),
  last_name_kana: yup.string()
      .required('姓（カナ）をご入力ください')
      .test(
          'max-width',
          `姓（カナ）は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      )
      .test('katakana', `姓（カナ）は${KATAKANA_ERROR_MESSAGE}`, function(value) {
        return KATAKANA_PATTERN.test(value);
      }),
  prefecture_id: yup.number().required('都道府県を必ず指定してください'),
  address: yup.string()
      .required('市区町村・番地をご入力ください')
      .test(
          'max-width',
          `市区町村・番地は全角100文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 200
      ),
  building_room: yup.string()
      .nullable()
      .test(
          'max-width',
          `建物名・部屋番号は全角100文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 200
      ),
  occupation: yup.string()
      .nullable(),
  gender: yup.string().required('性別をご入力ください').test('Empty', '性別が正しくありません', code => !code || /^[1-3]+$/.test(code)),
  postal_code: yup.string().required('居住地郵便番号をご入力ください').test('Empty', '居住地郵便番号が正しくありません', code => !code || /^\d{7}$/.test(code)),
  birth_month: yup.string().required('生年月（月）は必ず指定してください。'),
  birth_year: yup.string().required('生年月（年）は必ず指定してください。'),
  store_id: yup.number().required('お気に入り店舗を必ず指定してください'),
  phone_number: yup.string()
      .required('電話番号をご入力ください')
      .matches(/^[0-9]{10,30}$/, '電話番号は10〜30桁でご入力ください'),
  password: yup.string()
      .required('パスワードをご入力ください')
      .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,20}$/, 'パスワードは半角英数8〜20文字でご入力ください'),
  password_confirmation: yup.string()
      .required('確認用パスワードをご入力ください')
      .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,20}$/, '確認用パスワードは半角英数8〜20文字でご入力ください'),
}).test('birth_date', '生年月を完全に入力してください', function (value) {
  const { birth_year, birth_month } = value;
  if (!birth_year || !birth_month) {
    return this.createError({
      path: 'birth_date', // エラー表示の対象とするフィールド
      message: '生年月を完全に入力してください。',
    });
  }
  return true;
})

const ecUnite = useForm({
  validationSchema: schema,
  initialValues: {
    gender: 1,
    mail_flg: 2,
    is_agreed_to_terms: false,
    store_id: null,
    occupation: ''
  }
})

const { setFieldError } = ecUnite

const errors = useFormErrors();

const { value: postal_code } = useField<string>('postal_code')
const { value: last_name } = useField<string>('last_name')
const { value: first_name } = useField<string>('first_name')
const { value: last_name_kana } = useField<string>('last_name_kana')
const { value: first_name_kana } = useField<string>('first_name_kana')
const { value: prefecture_id } = useField<any>('prefecture_id');
const { value: address } = useField<any>('address');
const { value: building_room } = useField<any>('building_room');
const { value: phone_number } = useField<any>('phone_number');
const { value: password } = useField<string>("password")
const { value: password_confirmation } = useField<string>("password_confirmation")
const { value: gender } = useField<number>('gender');
const { value: birth_year } = useField<number>('birth_year');
const { value: birth_month } = useField<number>('birth_month');
const { value: occupation } = useField<string>('occupation');
const { value: mail_flg } = useField<number>('mail_flg');
const { value: email } = useField<string>('email');
const { value: store_id } = useField<any>('store_id');
//ユーザから同意を貰うために新規登録フロントだけに存在するフラグ、DBカラムはありません
const { value: is_agreed_to_terms } = useField<boolean>('is_agreed_to_terms');

async function fetchBrands() {
  const brandResponse = await getBrands();
  if (!brandResponse.status) {
    return
  }
  brands.value = brandResponse.data.brands
}

async function searchStore() {
  show_store_error.value = false;

  // 店舗コード未入力チェック
  if (!store_code.value || store_code.value.trim() === '') {
    setFieldError('store_id', 'お気に入り店舗を必ず指定してください');
    selected_brand.value = null;
    selected_prefecture.value = null;
    selected_store.value = null;
    return;
  }

  const storeResponse: any = await getStoreByCode(store_code.value);
  if(storeResponse.data.store) {
    const foundStore = storeResponse.data.store;
    selected_brand.value = foundStore.brand.id;
    await fetchPrefectures();
    selected_prefecture.value = foundStore.prefecture.id;
    await fetchStores();
    selected_store.value = foundStore.id
  } else {
    show_store_error.value = true;
    selected_brand.value = null;
    selected_prefecture.value = null;
    selected_store.value = null;
  }
}

onMounted(async () => {
  const prefectureResponse: any = await listAllPrefectures();
  if (!prefectureResponse.status) {
    return
  }
  allPrefectures.value = prefectureResponse.data?.prefectures ?? [];
});

const allPrefectures = ref<any>([]);
const show_store_error = ref(false);
const selected_brand = ref<any>('');
const selected_prefecture = ref<any>('');
const selected_store = ref<any>('');
const show_password = ref(false);
const show_confirm_password = ref(false);
const brands = ref<any>([]);
const prefectures = ref<any>([]);
const stores = ref<any>([]);
const progress_step = ref(0);

async function openTermsModal(url: string) {
  if (!url) {
    await presentToast('利用規約URLが設定されていません。');
    return;
  }
  window.location.href = `native:/action/open_browser?url=${encodeURIComponent(url)}`;
}

function checkSingleByteNumbers(event: Event): boolean {
  const re = /^[0-9]+$/g
  const target = event.target as HTMLInputElement
  return re.test(target.value)
}

watch([() => store_search_type.value], async () => {
  selected_brand.value = null;
  selected_prefecture.value = null;
  if (selected_store.value) {
    selected_store.value = null;
  }
})
watch([() => selected_store.value], async () => {
  store_id.value = selected_store.value;
})

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
    message: msg,
    duration: duration,
    spinner: spinner,
  })
}

async function validateForm() {
  const formValidity = await ecUnite.validate();
  const loading = await createLoading('登録中です...')
  if(formValidity.valid) {
    await loading.present()
    try {
      const data = {
        gender: gender.value,
        password: password.value,
        password_confirmation: password_confirmation.value,
        birth_year: birth_year.value,
        birth_month: birth_month.value,
        postal_code: postal_code.value,
        phone_number: phone_number.value,
        store_id: store_id.value,
        last_name: last_name.value,
        first_name: first_name.value,
        last_name_kana: last_name_kana.value,
        first_name_kana: first_name_kana.value,
        prefecture_id: prefecture_id.value,
        address: address.value,
        building_room: building_room.value,
        occupation: occupation.value,
        mail_flg: mail_flg.value,
        is_register: true,
        is_agreed_to_terms: is_agreed_to_terms.value
      }
      await request.post('/ec/unite-or-register', data);
      progress_step.value = 2;
    } catch(error: any) {
      if (!error.response) {
        datadogLogs.logger.error(error);
      }
      else if (error.response.status == 422) {
        progress_step.value = 0;
        ecUnite.setErrors(error.response.data.errors);
      }
    } finally {
      await loading.dismiss();
    }
  } else {
    progress_step.value = 0;
  }
}

async function getPostalCode() {
  if (/^\d{7}$/.test(postal_code.value)) {
    const postalData: PostalData[] = await getAddressFromPostalCode(postal_code.value);
    if (postalData.length > 1) {
      const inputs = postalData.map((item: PostalData) => ({
        name: item.town,
        type: 'radio' as const,
        label: (item.prefecture ?? '') + (item.city ?? '') + (item.town ?? '') + (item.koaza ?? ''),
        value: item
      }));
      const selectPrefectureAlert = await alertController.create({
        header: '住所を選んでください',
        inputs: inputs,
        buttons: [
          { text: 'Cancel', role: 'cancel' },
          {
            text: 'OK',
            handler: (selectedItem) => {
              setSelectedPrefecture(selectedItem);
            }
          }
        ]
      })
      await selectPrefectureAlert.present();
    }
    else if (postalData.length === 1) {
      setSelectedPrefecture(postalData[0])
    }
  }
}

function setSelectedPrefecture(selectedPrefecture: PostalData) {
  const prefecture = allPrefectures.value.find((item: Prefecture) => item.name == selectedPrefecture.prefecture);
  if (prefecture) {
    prefecture_id.value = prefecture.id;
  }
  address.value = (selectedPrefecture.city ?? '') + (selectedPrefecture.town ?? '') + (selectedPrefecture.koaza ?? '');
}

async function fetchPrefectures() {
  selected_prefecture.value = null;
  selected_store.value = null;
  if (selected_brand.value) {
    const prefectureResponse: any = await getPrefectures(selected_brand.value);
    if (!prefectureResponse.status) {
      return
    }
    prefectures.value = prefectureResponse.data?.prefectures ?? [];
  }
}

async function fetchStores() {
  if (selected_store.value) {
    selected_store.value = null;
  }
  if (selected_prefecture.value && selected_brand.value) {
    const storesResponse: any = await getStores(selected_brand.value, selected_prefecture.value);
    if (!storesResponse.status) {
      return
    }
    stores.value = storesResponse.data?.stores ?? [];
  }
}

onIonViewWillEnter( async () => {
  const response = await profile()
  const user = response.data.user

  postal_code.value = user.postal_code;
  phone_number.value = user.phone_number;
  email.value = user.email;
  if (user.birth_year) {
    birth_year.value = user.birth_year;
  }
  if (user.birth_month) {
    birth_month.value = user.birth_month;
  }
  if (user.last_name) {
    last_name.value = user.last_name;
  }
  if (user.gender) {
    gender.value = user.gender
  }
  if (user.first_name) {
    first_name.value = user.first_name;
  }
  if (user.last_name_kana) {
    last_name_kana.value = user.last_name_kana;
  }
  if (user.first_name_kana) {
    first_name_kana.value = user.first_name_kana;
  }
  if (user.address) {
    address.value = user.address;
  }
  if (user.occupation) {
    occupation.value = user.occupation;
  }
  if (user.building_room) {
    building_room.value = user.building_room;
  }
  if (user.address_prefecture_id) {
    prefecture_id.value = user.address_prefecture_id;
  }
  const memberCardData = await memberCard();
  point.value = memberCardData?.data?.user?.extendable_point ?? 0;

  await fetchBrands();
  selected_brand.value = user.brand_id ?? null;
  await fetchPrefectures();
  selected_prefecture.value = user.prefecture_id ?? null;
  await fetchStores()
  selected_store.value = user.store_id ?? null;
})
</script>

<style scoped lang="scss">

ion-backdrop {
  background: var(--ion-color-dark);
  opacity: 0.3;
}

.text-sm {
  font-size: 14px;
}

.text-blue {
  color: #00AFEC
}

.required-input {
  --background: #EFEFEF;
}

ion-input {
  --padding-start: 10px;
}

.terms-link {
  padding-left: 5px;
}
</style>
